let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4MDcN")).then(() => parcelRequire('8A4Kb'));